<template>
  <div id="app" :class="{'version_en': language == 'en'}">
    <template v-if="meta && !isEmptyObject(meta)">
      <DashHeader3 v-if="meta.head == 2 || meta.head == 3" class="homeHeader" />
      <DashHeader  v-if="meta.head != 2 && meta.head != -1 && meta.head != 3" />
      <menuItem    v-if="meta.head != 2 && meta.head != -1 && meta.head != 3" :class="{'grayBackground': meta.whiteBackground}" />
    </template>
    <div :key="Key">
      <!-- 需要缓存 -->
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          :class="{ 'p-t-118': meta.head == 3 || meta.head == 2, 'p-t-68': meta.head != 2 && meta.head != -1 && meta.head != 3 }"
        />
      </keep-alive>
      <!-- 不需要缓存 -->
      <router-view
        v-if="!$route.meta.keepAlive"
        :class="{ 'p-t-118': meta.head == 3 || meta.head == 2, 'p-t-68': meta.head != 2 && meta.head != -1 && meta.head != 3 }"
      />
    </div>
    <ChatMedia v-if="(isHttps && !isIE && showMedia) || (webIMDebug && showMedia)" />
    <!-- <ChatWithEmployee /> -->
    <v-chat-width-employee-tim v-if="isTIM" />
    <noticeDialog></noticeDialog>
    <noticeDialogActor></noticeDialogActor>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import webIMConfig from '@/utils/webIMConfig'
import { browser } from '@/utils/function'
// import ChatWithEmployee from '@/components/chat/ChatWithEmployee'
import ChatWithEmployeeTim from '@/components/Tim/ChatWithEmployee'
import ChatMedia from '@/components/chat/ChatMedia'
import DashHeader from '@/components/head/DashHeader'
import DashHeader3 from '@/components/head/indexHeader.vue'
import noticeDialog from '@/components/dialog/noticDialog.vue'
import noticeDialogActor from '@/components/dialog/noticDialogActor.vue'

import menuItem from '@/components/head/menuItem'
import { noticeListType } from '@/api/index'

export default {
  components: {
    // ChatWithEmployee,
    'v-chat-width-employee-tim': ChatWithEmployeeTim,
    ChatMedia,
    DashHeader,
    DashHeader3,
    menuItem,
    noticeDialog,
    noticeDialogActor
  },
  data() {
    return {
      Key: '',
      webIMDebug: webIMConfig.isDebug,
      showMedia: webIMConfig.showMedia,
      isIE: browser.trident,
      isHttps: window.location.protocol === 'https:'
    }
  },
  computed: {
    meta: function() {
      return this.$route.meta || ''
    },
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'isTIM', 
      'customerServiceInfo',
      'currentUserProfile',
      'conversationList'
    ]),
  },
  watch: {
    $route() {
      const meta = this.$route.meta
      this.Key = new Date().getTime()

      // 设置背景色
      if(meta) {
        setTimeout(() => {
          let body = document.querySelector('body')
          if (! body) return
          if (meta.whiteBackground) {
            body.classList.add('bodyWhite')
          } else {
            body.classList.remove('bodyWhite')
          }
        }, 0)
      }
    },
    isLogin: {
      handler() {
        // if (!this.isLogin) {
        //   clearInterval(this.timers)
        //   this.timers = null
        // } else {
        //   this.timers = setInterval(() => {
        //     // 定时器操作
        //     this.getList()
        //   }, 60000)
        // }
      },
      // deep: true
    }
  },
  async mounted() {
    if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
      await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
      console.log('APP页面登录')
    }
    if (this.isIE) {
      this.$notify({
        title: this.$t('Confirm'),
        message: this.$t('Chat features will not work if you keep using IE, please try other brwosers'),
        type: 'warning',
        duration: 0
      })
    }

    this.globalListening()
    this.getFromUrl()
    this.getInvitation()
  },
  methods: {
    /** 全局监听
     * 网络监听
     * 消息监听
     */
    globalListening() {
        // this.$nextTick(() => {
        //     if (this.isLogin) {
        //         this.timers = setInterval(() => {
        //         // 定时器操作
        //         this.getList()
        //         }, 60000)
        //     }
        // })

        const onLine = () => {
            this.$notify.success({
                message: this.$t('onLine')
            })
        }
        const offLine = () => {
            this.$notify.error({
                message: this.$t('offLine')
            })
        }

        window.addEventListener('online', onLine, false)
        window.addEventListener('offline', offLine, false)

        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('online', onLine)
            window.removeEventListener('offline', offLine)

            // if (this.timers) {
            //     clearInterval(this.timers)
            //     this.timers = null
            // }
        })
    },
    // 收集广告位分享的来源
    getFromUrl() {
      let search = window.location.search
      if (!search) return
      search = search.substr(1)
      let pathName = window.location.pathname
      let origin = window.location.origin
      let logsPath = ['/login', '/'] //埋点的地址
      let params = this.parser(search)
      if (params.fromUrl) {
        this.$store.commit('SET_FROMURL', params.fromUrl)
      }
      if (!logsPath.includes(pathName)) return
      this.$store.commit('SET_ADVERTISING_SHARING', origin + pathName)
    },
    /**
     * 收集展商邀请函的来源
     * 展商通过邀请函 给 客商邮箱 发送 参加展会的邮件（本展商的详情）
     */
    getInvitation() {
      let sendPath = ['/find-exhibitor/detail/', '/find-exhibit/detail/']
      let pathName = window.location.pathname
      let search = window.location.search
      if (!pathName || sendPath.includes(pathName)) return
      if (!search) return
      search = decodeURIComponent(search)
      search = search.substr(1)
      let params = this.parser(search)
      let id
      if (!params.email || !params.userAccountId) return
      if (params.exhibitorId) {
        id = params.exhibitorId
      } else {
        id = pathName.split("/")
        id = id[id.length - 1]
      }
      if (/([0-9A-Za-z]{10,}$)/.test(id) === false) return
      if (params.userAccountId) {
        this.$store.commit('SET_INVITATION_SOURCE', {
          exhibitorId: id,
          exhibitorEmployeeUserAccountId: params.userAccountId,
          email: params.email
        })
        this.invitationStatistics()
      }
    },
    getList() {
      if (this.isLogin && (this.subjectType == 'ACTOR' || this.subjectType == 'VISITOR')) {
        noticeListType({}).then(res => {
          var noticeListArr
          var inviteSeen = true
          var sponsorSeen = true
          var checkresultSeen = true
          var intentionorderSeen = true
          noticeListArr = res.data.data || []
          if (noticeListArr.length > 0) {
            for (let i in noticeListArr) {
              if (noticeListArr[i]['noticeType'] == 'SPONSOR') {
                sponsorSeen = noticeListArr[i]['seen']
              }
              if (noticeListArr[i]['noticeType'] == 'CHECKRESULT') {
                checkresultSeen = noticeListArr[i]['seen']
              }
              if (noticeListArr[i]['noticeType'] == 'INVITE') {
                inviteSeen = noticeListArr[i]['seen']
              }
              if (noticeListArr[i]['noticeType'] == 'INTENTIONORDER') {
                intentionorderSeen = noticeListArr[i]['seen']
              }
            }
            if (inviteSeen && sponsorSeen && checkresultSeen && intentionorderSeen) {
              this.$store.commit('setNewMailStatus', false)
            } else {
              this.$store.commit('setNewMailStatus', true)
            }
          }
        })
      }
    }
  }
}
</script>
<style lang="stylus">
@import url('//at.alicdn.com/t/font_1810802_bl4de3d581h.css');
@import './styles/reset'
@import './styles/style'
@import './styles/dash'
@import './styles/home'
@import './styles/loginAndRegister'
@import './styles/respon'
@import './styles/hotspot'

* {
  outline none
}
html, body{
  height 100%
}
body
  min-width $container-width-min
  background $color-gray-fb
  overflow auto
  font-family Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif
  // font-family: OpenSans, "siyuan"
  font-family: OpenSans, 'pingfang';
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale

&.bodyWhite {
  background $color-white
}
.iconfont,
.iconfont-el
  font-size 14px
  margin 9px 8px
  min-width 14px
#app
  color #2c3e50
  min-height 100vh
#nprogress .bar
  background $color-main !important
.v-live-rotate-1 .vcp-video,.v-live-rotate-1 video{
  transform:rotate(90deg)
}
.v-live-rotate-2 .vcp-video,.v-live-rotate-2 video{
  transform:rotate(180deg)
}
.v-live-rotate-3 .vcp-video,.v-live-rotate-3 video{
  transform:rotate(270deg)
}
</style>
